import style from './ProjectItem.module.css';

import { useNavigate, useParams } from 'react-router-dom';

import { useMemo, useState } from 'react';

const ProjectItem = ({ info, handleDelete }) => {
  const { lang = 'en' } = useParams();
  const navigate = useNavigate();
  const to = info.websiteUrl;
  const title = useMemo(() => {
    return info.titles.find(el => {
      return el.language === lang;
    })?.title;
  }, [lang, info]);

  const desc = useMemo(() => {
    return info.descriptions.find(el => {
      return el.language === lang;
    })?.description;
  }, [lang, info]);

  const img = info.imageUrl;

  return (
    <div className={style.gradientContainer}>
      <article className={style.projectItem}>
        <h1>{title}</h1>

        {img ? (
          <div className={style.imgContainer}>
            <img src={img} alt={title} loading="lazy" />
          </div>
        ) : null}

        <div className={style.descriptionContainer}>
          <p>{desc}</p>
        </div>

        <button
          type="button"
          className={style.deleteBtn}
          onClick={handleDelete}
        >
          Delete
        </button>
      </article>
    </div>
  );
};

export default ProjectItem;
